import React from 'react';
import { slide as Menu } from 'react-burger-menu';

import { MainNavStyles } from '../styles/common.css';

class MainNav extends React.Component {
  render() {
    return (
      <MainNavStyles>
        <Menu right>
          <a id="privacy" className="menu-item" href="/privacy">
            Privacy
          </a>
          <a id="tou" className="menu-item" href="/tou">
            Terms of Use
          </a>
        </Menu>
      </MainNavStyles>
    );
  }
}

export default MainNav;
